import React, { useState, useCallback, useEffect } from 'react'
import {
  Stack,
  Button,
  SimpleModal,
  Text,
  Checkbox
} from '@/components/lib'
import api from '@/api'
import utils from '@/utils/utils'

export default function StageScheduleResetPopover ({
  isOpen,
  onClose,
  trialId,
  participantId,
  /** Stage row from `listStages` (non–ad-hoc timepoint). */
  stage,
  onReset
}) {
  const [resetting, setResetting] = useState(false)
  const [resetAll, setResetAll] = useState(false)

  const isMultiRecurrenceStage =
    !!stage?.isRecurring && (stage?.recurringDuration ?? 0) > 1

  useEffect(() => {
    if (isOpen) setResetAll(false)
  }, [isOpen])

  const handleReset = useCallback(() => {
    if (!trialId || !participantId || !stage) return
    setResetting(true)
    api.participants.deleteStageOverride(
      trialId,
      participantId,
      utils.timelineStageMongoId(stage),
      stage.recurrence ?? 0,
      isMultiRecurrenceStage && resetAll,
      () => {
        setResetting(false)
        utils.toast('success', 'Schedule reset')
        onReset?.()
        onClose?.()
      },
      (err) => {
        setResetting(false)
        utils.toast('error', err.message || 'Could not reset schedule')
      }
    )
  }, [trialId, participantId, stage, resetAll, isMultiRecurrenceStage, onReset, onClose])

  return (
    <SimpleModal
      size='sm'
      isOpen={isOpen}
      onClose={onClose}
      header='Reset schedule'
      body={
        <Stack gap={4}>
          <Text>Reset this stage back to its originally scheduled date?</Text>
          {isMultiRecurrenceStage && (
            <Checkbox
              checked={resetAll}
              onChange={(e) => setResetAll(!!e.checked)}
            >
              Also reset other recurrences of this stage
            </Checkbox>
          )}
        </Stack>
      }
      footer={
        <Stack direction='row' gap={2} justifyContent='flex-end'>
          <Button variant='ghost' onClick={onClose} disabled={resetting}>
            Cancel
          </Button>
          <Button colorPalette='red' onClick={handleReset} loading={resetting}>
            Reset
          </Button>
        </Stack>
      }
    />
  )
}
